import { Injectable } from '@angular/core';

import { DynamicAsideMenuConfig } from '../../_layout/configs/dynamic-aside-menu.config';
import { PermissionService } from './permission.service';
import { PERMISSION } from '../constants/permissions-constants';

@Injectable({ providedIn: 'root' })
export class RedirectService {

  constructor(
    private permissionService: PermissionService
  ) { }

  get accessDeniedUrl() {
    return '/403';
  }

  get redirectUrl() {
    const pages = DynamicAsideMenuConfig.items;
  
    for (let i = 0; i < pages.length; i++) {
      const page = pages[i];
      const hasPermission = page.permission === PERMISSION.Pages_Tenant_Dashboard 
        ? this.permissionService.hasDashboardPermission() 
        : this.permissionService.hasPermission(page.permission);
      
      if (hasPermission && page.page) {
        return page.page;
      }
    }
  
    return this.accessDeniedUrl;
  }  
  
}
